import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, map, catchError, of } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomTranslateLoaderService implements TranslateLoader {

  constructor(private http: HttpClient) { }

  public getTranslation(lang: string): Observable<any> {
    return this.http.get(`${environment.URL_API}labels/${lang}`).pipe(
      map((res: any) => {
        return res.labels;
      },
      ),
      catchError(e => of())
    )
  }
}
